export class StoryEdgeOptions {
    constructor(id, source, target, actionData) {
        this.id = id;
        this.source = source;
        this.target = target;
        this.actionData = actionData;
    }
}
export class StoryEdgeOptionsActionData {
    constructor(lineType, enterText, identifierType, identifierValue, queryValue, 
    // FIXME TYPE
    requestParam, funcOriginalData, fileUuid, blueJson) {
        this.lineType = lineType;
        this.enterText = enterText;
        this.identifierType = identifierType;
        this.identifierValue = identifierValue;
        this.queryValue = queryValue;
        this.requestParam = requestParam;
        this.funcOriginalData = funcOriginalData;
        this.fileUuid = fileUuid;
        this.blueJson = blueJson;
    }
}
export class StoryEdgeOptionsActionDataRequestParams {
    constructor(loader, file, name, s3Url, urls) {
        this.loader = loader;
        this.file = file;
        this.name = name;
        this.s3Url = s3Url;
        this.urls = urls;
    }
}
export class StoryEdgeOptionsFuncOriginalData {
    constructor(id, value, functionName) {
        this.id = id;
        this.value = value;
        this.functionName = functionName;
    }
}
